import { render, staticRenderFns } from "./Fourth_2.vue?vue&type=template&id=48dbb20f&"
import script from "./Fourth_2.vue?vue&type=script&lang=js&"
export * from "./Fourth_2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports